// src/hooks/useGoogleCallback.js
// Add this import to LoginPage.jsx:
// import useGoogleCallback from '../hooks/useGoogleCallback';
// And call it at the top of the component: useGoogleCallback();

import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { saveAuth } from '../api/auth';
import { FALLBACK_NEXT, takeStashedNext } from '../lib/nextUrl';

function useGoogleCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const name  = searchParams.get('name');
    const email = searchParams.get('email');
    const error = searchParams.get('error');
    // Google hands back id, email and name and nothing else, so a Google
    // sign-up never has a WhatsApp number. The backend says so in the redirect
    // and ProfileGuard acts on it.
    const needsPhone = searchParams.get('needsPhone') === '1';

    if (error === 'google_failed') {
      // Error is handled by LoginPage showing error state
      return;
    }

    if (token && email) {
      saveAuth(token, { name, email, needsPhone });
      // Where the user was headed before the round-trip. ?next= cannot survive
      // it (the backend builds the return URL and echoes nothing of ours), so
      // it was parked in sessionStorage on the way out.
      const next = takeStashedNext() || FALLBACK_NEXT;
      // replace, for two reasons. This is a redirect caused by state, so back
      // must not land on a /login that only redirects again. And the URL being
      // replaced holds the JWT, the name and the email as query parameters:
      // pushing would leave all three sitting in history and in the address
      // bar of the previous entry.
      navigate(next, { replace: true });
    }
  }, [searchParams, navigate]);
}

export default useGoogleCallback;
